import { atom } from "jotai";

export const userSettingsAtom = atom<Record<string, unknown>>({});
